import React from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import Loader from "@icarius-common/loader";
import { updateEvaluationProcessDefinitionAction } from "@icarius-pages/evaluationProcessDefinition/actions";
import useHandleForm from "./createEditForm/useHandleForm";
import ChangeStatusInput from "./createEditForm/changeStatusInput";

const ChangeStatusDialog = (props) => {

  const {
    open,
    data,
    formList,
    scoreTypeList,
    statusList,
    isLoading,
    handleClose,
  } = props;

  const dispatch = useDispatch();

  const modify = (dataToSend) => {
    dispatch(updateEvaluationProcessDefinitionAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = (errorMessage) => {
    dispatch(openSnackbarAction({ msg: errorMessage || getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit,
  } = useHandleForm(data, null, modify, openValidationError, formList, scoreTypeList);

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      maxWidth={"sm"}
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {`Pasos y etapas de la evaluación: ${data.processName}`}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ padding: 14, paddingTop: 0, paddingBottom: 0 }}>
        <Loader open={isLoading} />
        <ChangeStatusInput
          data={data}
          formData={formData}
          setFormValue={setFormValue}
          statusList={statusList}
        />
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
        <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
      </DialogActions>
    </Dialog>
  );
}

export default ChangeStatusDialog;